export const ACTIONS = {
  OPEN_NEW: "OPEN_NEW",
  CLOSE_NEW: "CLOSE_NEW",
};
